import React, { Fragment, useState } from "react";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  useTheme,
} from "@mui/material";
import axios from "../../utils/axios.tsx";
import { searchFieldActions } from "../../store/search/searchField.tsx";
import { useDispatch } from "react-redux";

interface FavouritesQuestionRowProps {
  text: string;
  id: string;
  index: number;
}

const FavouritesQuestionRow: React.FC<FavouritesQuestionRowProps> = (props) => {
  const dispatch = useDispatch();
  const [displayEditOptions, setEditOptions] = useState(false);
  const [displayText, setDisplayText] = useState(props.text);
  const theme = useTheme();
  const handleSaveClick = async (favouriteQuestionId: string) => {
    await axios
      .post(
        "/v1/favourite/",
        JSON.stringify({ text: displayText, id: favouriteQuestionId }),
      )
      .then((_) => {
        setEditOptions(false);
      });
  };

  const handleReplayClick = () => {
    dispatch(searchFieldActions.setGlobalSearchText(displayText));
  };

  return (
    <Fragment>
      {displayEditOptions ? (
        <Grid
          container
          direction="row"
          spacing={2}
          alignContent="flex-start"
          alignItems="flex-start"
        >
          <Grid size={{ xs: 12, lg: 12 }} sx={{ paddingTop: "0 !important" }}>
            <TextField
              className={"editFavouriteQuestion"}
              defaultValue={displayText}
              sx={{ minWidth: "100%", marginTop: ".5em" }}
              onChange={(e) => setDisplayText(e.target.value)}
            />
          </Grid>
          <Grid size={{ xs: 12, lg: 12 }} sx={{ paddingTop: "0 !important" }}>
            <Button onClick={() => setEditOptions(false)}>Cancel</Button>
            <Button onClick={() => handleSaveClick(props.id)}>Save</Button>
          </Grid>
        </Grid>
      ) : (
        <Box>
          <InputLabel>
            #{props.index} {displayText}
          </InputLabel>
          <Grid size={{ xs: 12, lg: 12 }}>
            <Button
              onClick={() => setEditOptions(true)}
              sx={{
                cursor: "pointer",
                color: theme.palette.primary.main,
                fontSize: "0.8rem",
                height: "3em",
              }}
            >
              Edit
            </Button>
            <Button
              onClick={handleReplayClick}
              sx={{
                cursor: "pointer",
                color: theme.palette.primary.main,
                fontSize: "0.8rem",
                height: "3em",
              }}
            >
              Replay
            </Button>
          </Grid>
        </Box>
      )}
    </Fragment>
  );
};

export default FavouritesQuestionRow;
